import { render, staticRenderFns } from "./returnGoodsPup.vue?vue&type=template&id=4aaca0a4&scoped=true&"
import script from "./returnGoodsPup.vue?vue&type=script&lang=js&"
export * from "./returnGoodsPup.vue?vue&type=script&lang=js&"
import style0 from "./returnGoodsPup.vue?vue&type=style&index=0&id=4aaca0a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaca0a4",
  null
  
)

export default component.exports